import "./AuthorProfileElement-style";

class AuthorProfileElement extends HTMLElement {
    // server rendered for now
}

customElements.define("author-profile", AuthorProfileElement);